export const formatPriceToFixed = (value) => {
  if (value === undefined || value === null || value === "") return null;
  const num = parseFloat(value);
  if (Number.isNaN(num)) return null;
  return num.toFixed(2);
};
